import { create } from "zustand"

import { UserSelectFilterType } from "../../../types"

interface RewardsUserSelectStore {
  selectedUserId: number | null
  selectedFilterType: UserSelectFilterType
  setSelectedUserId: (userId: number | null) => void
  setSelectedFilterType: (filterType: UserSelectFilterType) => void
}

const useRewardsUserSelectStore = create<RewardsUserSelectStore>((set) => ({
  selectedUserId: null,
  selectedFilterType: UserSelectFilterType.ALL_KIDS,
  setSelectedUserId: (userId) => {
    set({ selectedUserId: userId })
    if (userId) set({ selectedFilterType: UserSelectFilterType.USER })
  },
  setSelectedFilterType: (selectedFilterType) => {
    if (selectedFilterType !== UserSelectFilterType.USER)
      set({ selectedUserId: null })
    set({ selectedFilterType })
  },
}))

export default useRewardsUserSelectStore
